
Number.prototype.toBool = function () {
  return this == 1;
};
